import { Autocomplete, Button, Grid, Paper, TextField, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SearchRounded } from "@mui/icons-material";
import { useSetRecoilState } from "recoil";
import { useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { IFormSearchLeadModel, initialLeadModelFilters, leadModelFiltersAtom } from "../../../state/leadModel";

const OperatorSearch = () => {
    const theme = useTheme();
    const { t } = useTranslation(['operator']);
    const { globalData } = useContext(GlobalContext);
    const legalEntities = globalData?.user?.legalEntities || [];

    const setLeadModelFilters = useSetRecoilState(leadModelFiltersAtom);

    const { handleSubmit, formState: { errors }, control } = useForm<IFormSearchLeadModel>({
        defaultValues: initialLeadModelFilters
    });

    const onSubmit = (params: IFormSearchLeadModel) => {
        setLeadModelFilters(params)
    };

    return (
        <Paper style={{
            borderRadius: "4px",
            padding: theme.spacing(1) + ' ' + theme.spacing(2),
            marginBottom: theme.spacing(2)
        }}
            elevation={1}
        >
            <form
                onSubmit={handleSubmit(onSubmit)}
            >
                <Grid container
                    spacing={theme.spacing(2)}
                    alignItems="flex-end"
                >
                    <Grid item md={3} xs={12}>
                        <Controller
                            control={control}
                            name="legalEntity"
                            render={({ field: { onChange, value } }: any) => (
                                <Autocomplete
                                    limitTags={1}
                                    disableCloseOnSelect={true}
                                    id={'legalEntity'}
                                    options={legalEntities}
                                    value={value || null}
                                    getOptionLabel={(option: any) => t('translation:legalEntities.'.concat(option.name))}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label={t("label.legalEntity")}
                                            error={Boolean(errors.legalEntity)}
                                            helperText={t(errors.legalEntity?.message as string)}
                                        />
                                    )}
                                    onChange={(_, value) => {
                                        onChange(value)
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item md={9} xs={12}>
                        <Grid container spacing={theme.spacing(2)}
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-end"
                        >
                            <Grid item>
                                <Button type={'submit'} size={'icon'} color={'accent'}>
                                    <SearchRounded />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Paper>
    );
}

export default OperatorSearch;
